// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oyu6R","title":"styles_title__8czGd"};